import { useContext } from 'react';

import { DeviceFaultyForm, Modal } from '@/components';
import { ModalContext } from '@/context';

import styles from './deviceFaultyFormModal.module.scss';

export const DeviceFaultyFormModal = () => {
	const { showDeviceFaultyFormModal, setShowDeviceFaultyFormModal, setShowReportIssueForm } =
		useContext(ModalContext);

	const handleClose = () => {
		setShowDeviceFaultyFormModal(false);
		setShowReportIssueForm(false);
	};

	return (
		<Modal
			customModalStyle={styles['custom-modal']}
			customBackdropStyle={styles['custom-backdrop']}
			open={showDeviceFaultyFormModal}
			closeable
			isDismissable={false}
			handleClose={handleClose}
		>
			<div className={styles['modal-header']}>
				<p className={styles['modal-title']}>Report faulty device</p>
				<p className={styles['modal-subtitle']}>Please tell us more about the faulty device.</p>
			</div>
			<DeviceFaultyForm handleSuccess={handleClose} />
		</Modal>
	);
};
